<template>
  <div class="app-container-v2 table-container-v2">
    <div class="title-box">
      <div class="title-left">
        <span class="title-text">{{ $t('menu.policyLibraryPermission') }}</span>
      </div>
    </div>
    
    <div class="table-body flex vertical" v-loading="loading">
      <air-table
        ref="airTable"
        class="table-v2"
        :show-checkbox="false"
        align="center"
        :columns="columns"
        :data="tableData"
        :operation-column-width="100"
        @change-filter="changeFilter"
      >
        <template #operation="{ row }">
          <div class="flex center mt4">
            <span class="text-button" @click="handleEdit(row)">{{ $t('handleEdit') }}</span>
          </div>
        </template>
      </air-table>
  
      <pagination :pager-config.sync="pagerConfig" @page-change="pageChange"></pagination>
    </div>
    
    <el-dialog class="modal-v2" :title="modal.title" :visible.sync="modal.show" :close-on-click-modal="false" width="700px" append-to-body @closed="reset" v-dialog-drag>
      <el-form ref="form" class="form-v2" :model="form" :rules="formRules" :label-width="lang == 'en' ? '210px' : '120px'" style="margin: 40px 0; padding: 0 30px;" size="small" label-suffix="：">
        <el-form-item class="fixed-height" :label="$t('customerName')">
          <div class="text-left">{{ form.cusName }}</div>
        </el-form-item>
        <el-form-item class="fixed-height" :label="$t('customerNumber')">
          <div class="text-left">{{ form.cusId }}</div>
        </el-form-item>
        <el-form-item :label="$t('policyLibraryPermissions')" prop="scopes">
          <el-select class="select-v2 auto-height" v-model="form.scopes" multiple filterable clearable>
            <el-option v-for="item in setIdByItemList" :key="item.codeItemId" :value="item.codeItemId" :label="item[getTitle] ? item[getTitle] : item.codeItemName" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="w100 flex jbetween acenter">
        <el-button plain class="button-v2" @click="modal.show = false">{{ $t('cancel') }}</el-button>
        <el-button type="primary" class="button-v2" :loading="submitLoading" @click="handleSave">{{ $t('save') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import Pagination from '@/components/bsp/bsp-pagination/bsp-pagination';
  import * as api from '@/api/policy/policyLibraryManagement';
  import * as apiA from '@/api/policy/policyLibrary';
  import { mapGetters } from 'vuex';
  import { dictListFilter } from "@/filters";

  export default {
    name: 'PolicyLibraryPermission',
    components: {
      Pagination
    },
    data() {
      return {
        setIdByItemList: [],
        loading: true,
        pagerConfig: {
          page: 1,
          limit: 20,
          total: 0
        },
        queryParams: {
        },
        total: 0,
        columns: [
          {title: this.$t('customerName'), field: 'cusName', minWidth: 150, filterType: 'input'},
          {title: this.$t('customerNumber'), field: 'cusId', minWidth: 150, filterType: 'input'},
          {title: this.$t('policyLibraryPermissions'), field: 'scopesText', minWidth: 350, filterType: 'select', filterOptions: [], filterMultiple: true, }
        ],
        tableData: [],
        form: {
          scopes: []
        },
        formRules: {
          scopes: [{ required: true, message: this.$t('pleaseSelect'), trigger: 'change' }]
        },
        modal: {
          show: false,
          title: this.$t('handleEdit')
        },
        submitLoading: false
      }
    },
    computed: {
      ...mapGetters(['dicts', 'lang']),
      getTitle() {
        return this.lang == 'en' ? 'codeItemEnName' : 'codeItemName';
      }
    },
    created() {
      this.init();
    },
    methods: {
      resetForm(formName) {
        if (this.$refs[formName] !== undefined) {
          this.$refs[formName].resetFields();
        }
      },
      pageChange({ type, currentPage, pageSize }) {
        if (type == 'size') {
          this.pagerConfig.page = 1;
        }
        this.getData();
      },
      // 获取适用范围
      getSetIdByItemList() {
        return new Promise((resolve, reject) => {
          let params = {
            setList: 1036
          }
          apiA.setIdByItemList(params)
            .then(res => {
              this.setIdByItemList = res.data.data;
              this.columns[2].filterOptions = this.setIdByItemList;
              resolve(true);
            })
            .catch(error =>{
              reject(error);
              this.setIdByItemList = [];
              this.column[2].filterOptions = [];
            })
        })
      },
      init() {
        this.getSetIdByItemList()
          .then(() => {
            this.getData();
          })
          .catch(error => {
            this.loading = false;
          })
      },
      getData() {
        this.loading = true;
        const { page, limit } = this.pagerConfig;
        let params = {
          pageNum: page,
          pageSize: limit,
          ...this.queryParams
        }
        api.authList(params)
          .then(res => {
            let { list, total } = res.data.data;
            list = JSON.parse(JSON.stringify(list));
            list.forEach(item => {
              if (item.scopes && item.scopes.split(',').length > 0) {
                let scopesCode = item.scopes.split(',');
                let scopesText = [];
                scopesCode.forEach(subItem => {
                  if (subItem) {
                    scopesText.push(dictListFilter(subItem, this.setIdByItemList));
                  }
                })
                item.scopesText = scopesText.join('，');
              }
            })
            this.tableData = list;
            this.pagerConfig.total = total;
            this.loading = false;
          })
          .catch(error => {
            this.loading = false;
          })
      },
      changeFilter(e) {
        this.queryParams = {...this.queryParams, ...e.filterData};
        this.pagerConfig.page = 1;
        this.getData();
      },
      reset() {
        this.form = {
          scopes: []
        }
        this.resetForm('form');
      },
      handleEdit(row) {
        const scopes = row.scopes.split(',');
        this.form = {
          ...row,
          scopes
        }
        this.modal.show = true;
      },
      handleSave() {
        this.$refs.form.validate(valid => {
          if (valid) {
            let { scopes } = this.form;
            let params = {
              ...this.form,
              scopes: scopes.join(',')
            }
            this.submitLoading = true;
            api.authUpdate(params).then(res => {
              if (res.data.code === 0) {
                this.modal.show = false;
                this.getData();
              }
            }).finally(() => this.submitLoading = false)
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "~@/air/assets/css/main.scss";
</style>
